import "./index.css";
import { clsx } from "clsx";
import { useTranslation } from "react-i18next";

type IProps = {
  password: string;
};

export const PasswordRequirementMessage = ({ password }: IProps) => {
  const { t } = useTranslation();

  const rules = [
    {
      test: (p: string) => p.length >= 8,
      messageKey: "label.passwordRuleMinLength",
    },
    {
      test: (p: string) => /[a-z]/.test(p),
      messageKey: "label.passwordRuleLowercase",
    },
    {
      test: (p: string) => /[A-Z]/.test(p),
      messageKey: "label.passwordRuleUppercase",
    },
    {
      test: (p: string) => /\d/.test(p),
      messageKey: "label.passwordRuleNumber",
    },
    {
      test: (p: string) => /[@#$%^&*\-_!+=[\]{}|\\:'",.?/`~();<> ]/.test(p),
      messageKey: "label.passwordRuleSymbol",
    },
  ];

  const requirementsJSX = rules.map((rule, index) => {
    const isValid = rule.test(password);
    return (
      <li
        key={index}
        className={clsx(
          isValid && "nuco-auth-common-form__password-requirement-met",
        )}
      >
        {t(rule.messageKey)}
      </li>
    );
  });

  return (
    <div className="nuco-auth-common-form__password-message nuco-text nuco-text--md">
      <ul>{requirementsJSX}</ul>
    </div>
  );
};
